// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__190_3","left":"styles_left__2IA_F"};